/* Topic landing + pdp-topic-* pages — GA4 click tracking (Pattern C + auto-detect).

   Loads only on page.topic-landing and page.pdp-topic-* via snippets/topic-page-tracking.liquid.

   One event name, fixed payload (many similar interactions):
     event:            topic_click
     topic_action      semantic action (cta, slider_prev, faq_toggle, …)
     topic_label       human-readable control label
     topic_section     Shopify section type (from section-* wrapper class)
     topic_section_id  Shopify section id
     topic_href        link/anchor href when relevant
     topic_page        Liquid template name (e.g. page.pdp-topic-stress)
     topic_handle      page handle when available

   Opt-in overrides on any element:
     data-track="cta"              → topic_action
     data-track-action="slider_prev"
     data-track-label="Hero CTA"
     data-track-ignore             → skip this subtree

   GTM: CE trigger event name ^topic_click$, one GA4 Event tag with {{Event}} = topic_click.

   NOTE: pushes to BOTH dataLayer and gtag (same as quiz). Remove gtag() if GTM forwards
   topic_click to the same GA4 property — see .cursor/plans/ga4-tracking-guide.md §7.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('topic-page-tracking-config');
  if (!configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (_) {}

  if (window.Shopify && window.Shopify.designMode) return;

  var root = document.getElementById('main-content');
  if (!root) return;

  var debug = !!config.debug;

  var TARGET_SELECTOR = [
    '[data-track]',
    '[data-track-action]',
    '[data-pc-close]',
    '[data-pc-open]',
    '[data-pdp-switcher-compare-open]',
    '[data-pdp-switcher-compare-close]',
    '[data-pdp-switcher-compare-add]',
    '[data-pdp-tab]',
    '[data-review-category]',
    '.gallery-slider__button',
    '.gallery-slider__dot',
    '.pdp-switcher-slider__nav',
    '.hero-topic__scroll-indicator',
    '.topic-selection__card',
    '.ftc__q',
    'summary.faq__q',
    '.faq__q',
    '[data-faq-more]',
    '.faq__more',
    '[data-ftc-more]',
    '.ftc__more',
    '.tabs-content__pill',
    '.pdp-switcher-select__option',
    '.main-cta',
    '.AddToCart',
    '.single-add-to-cart-button',
    '.universal-sticky-cta a',
    '.universal-sticky-cta button',
    'a[href]',
    'button:not([disabled])',
    '[role="button"]:not([aria-disabled="true"])',
  ].join(',');

  function ctrlLabel(el) {
    if (!el) return null;
    var t =
      (el.getAttribute &&
        (el.getAttribute('data-track-label') || el.getAttribute('aria-label'))) ||
      '';
    if (!t) t = el.textContent || '';
    t = t.replace(/\s+/g, ' ').trim();
    if (!t) return null;
    return t.length > 100 ? t.slice(0, 99) + '\u2026' : t;
  }

  function getSectionInfo(el) {
    var section = el.closest('.shopify-section');
    if (!section) return { id: null, type: null };
    var id = section.id ? section.id.replace('shopify-section-', '') : null;
    var type = null;
    var classes = section.classList;
    for (var i = 0; i < classes.length; i++) {
      var cls = classes[i];
      if (cls.indexOf('section-') === 0) {
        type = cls.slice('section-'.length);
        break;
      }
    }
    return { id: id, type: type };
  }

  function getHref(el) {
    if (el.matches && el.matches('a[href]')) return el.getAttribute('href');
    var link = el.closest && el.closest('a[href]');
    return link ? link.getAttribute('href') : null;
  }

  function classify(el) {
    var explicit =
      el.getAttribute('data-track-action') || el.getAttribute('data-track');
    if (explicit) return explicit;

    if (el.matches('[data-pc-close]') || el.matches('[data-pdp-switcher-compare-close]')) {
      return 'popup_close';
    }
    if (el.matches('[data-pc-open]') || el.matches('[data-pdp-switcher-compare-open]')) {
      return 'popup_open';
    }
    if (
      el.matches('.gallery-slider__button.prev') ||
      el.matches('.pdp-switcher-slider__nav--prev') ||
      el.matches('[data-pdp-switcher-slider-prev]')
    ) {
      return 'slider_prev';
    }
    if (
      el.matches('.gallery-slider__button.next') ||
      el.matches('.pdp-switcher-slider__nav--next') ||
      el.matches('[data-pdp-switcher-slider-next]')
    ) {
      return 'slider_next';
    }
    if (el.matches('.gallery-slider__dot')) return 'slider_dot';
    if (el.matches('.hero-topic__scroll-indicator')) return 'scroll_anchor';
    if (el.matches('.topic-selection__card')) return 'topic_card';
    if (el.matches('.ftc__q') || el.matches('summary.faq__q') || el.matches('.faq__q')) {
      return 'faq_toggle';
    }
    if (el.matches('[data-faq-more]') || el.matches('.faq__more')) return 'faq_more';
    if (el.matches('[data-ftc-more]') || el.matches('.ftc__more')) return 'faq_more';
    if (el.matches('.tabs-content__pill') || el.matches('[data-pdp-tab]')) return 'tab';
    if (el.matches('[data-review-category]')) return 'filter';
    if (el.matches('.pdp-switcher-select__option')) return 'product_select';
    if (
      el.matches('.main-cta') ||
      el.matches('.AddToCart') ||
      el.matches('.single-add-to-cart-button') ||
      el.matches('[data-pdp-switcher-compare-add]') ||
      el.closest('.universal-sticky-cta')
    ) {
      return 'cta';
    }
    if (el.matches('a[href^="#"]')) return 'anchor';
    if (el.matches('a[href]')) return 'link';
    if (el.matches('button, [role="button"]')) return 'button';
    return null;
  }

  function track(action, el) {
    var section = getSectionInfo(el);
    var payload = {
      topic_action: action,
      topic_label: ctrlLabel(el),
      topic_section: section.type,
      topic_section_id: section.id,
      topic_href: getHref(el),
      topic_page: config.page || null,
      topic_handle: config.handle || null,
    };

    try {
      window.dataLayer = window.dataLayer || [];
      var obj = { event: 'topic_click' };
      for (var k in payload) {
        if (payload.hasOwnProperty(k)) obj[k] = payload[k];
      }
      window.dataLayer.push(obj);
    } catch (_) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'topic_click', payload);
      }
    } catch (_) {}

    if (debug) {
      console.log('[topic_click]', payload);
    }
  }

  if (debug) {
    console.log('[topic_click] tracking active', {
      page: config.page,
      handle: config.handle,
    });
  }

  root.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[data-track-ignore]')) return;

      var el = target.closest(TARGET_SELECTOR);
      if (!el || !root.contains(el)) return;

      var action = classify(el);
      if (!action) return;

      track(action, el);
    },
    false,
  );
})();
